import { createSlice } from "@reduxjs/toolkit";

const queryInitialState = {
  query: "",
};

const querySlice = createSlice({
  name: "query",
  initialState: queryInitialState,
  reducers: {
    setStatusQuery(state, action) {
      state.query = action.payload;
    },
  },
});

export const { setStatusQuery } = querySlice.actions;
export const queryReducer = querySlice.reducer;
